import { fingerprint, cid, genkey } from './security';

export default (Config) => {
    const { apikey } = Config;

    return  {
        // called when the user attempts to log in
        login: ({ username, password }) => {
            const key = genkey(password);
            console.log('login', {Config, username, key });
            //localStorage.setItem('auth', username);

            const url = (Config.API_BASE || 'https://'+Config.domain+(Config.path || '/x/api'))+'/auth/login';
            
            const request = new Request(
                url, //'https://'+Config.domain+'/x/api/auth/login',
                {
                    method: 'POST',
                    body: JSON.stringify({ username, key }),
                    headers: new Headers({
                        "Content-Type": "application/json",
                        apikey, fingerprint, cid
                    }),
                }
            );
            return new Promise((resolve, reject)=>{
                
                fetch(request)
                    .then(response => {
                        if (response.status < 200 || response.status >= 300) {
                            throw new Error(response.statusText);
                        }
                        return response.json();
                    })
                    .then(data => {
                        const token = data && data.token;
                        if(!!token){
                            localStorage.setItem('token', token);
                            resolve();
                        }
                        else{
                            reject(data.error);
                        }
                    })
                    .catch(err=>{
                        reject(err);
                    })
                ;

            });
    
        },
        // called when the user clicks on the logout button
        logout: () => {
            localStorage.removeItem('token');
            return Promise.resolve();
        },
        // called when the API returns an error
        checkError: ({ status }) => {
            if (status === 401 || status === 403) {
                localStorage.removeItem('token');
                return Promise.reject();
            }
            return Promise.resolve();
        },
        // called when the user navigates to a new location, to check for authentication
        checkAuth: () => {
            return localStorage.getItem('token')
                ? Promise.resolve()
                : Promise.reject();
        },
        // called when the user navigates to a new location, to check for permissions / roles
        getPermissions: () => Promise.resolve(),
    };
}


// WEBPACK FOOTER //
// ./src/lib/authProvider.js